import styled from 'styled-components';

export const StyledAboutIntroWrapper = styled.div`
  height: 70vh;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(../img/aboutintro1.webp) no-repeat center center / cover;
  position: relative;
  text-transform: uppercase;
  overflow: hidden;
  z-index: 1;
  border-bottom: 2px solid #ffbc00;
  
  @media only screen and (max-width: 850px) and (orientation:portrait) {
  height: 40vh;
  }
  
  div, div.react-reveal {
  display: inline-block;
  }
`;


export const StyledAboutIntroTitle = styled.h2`
color: #fff3d1;
font-size: calc(12px + 1.7vw);
white-space: nowrap;
line-height: 1.7;
`;

export const StyledAboutIntroTitleWrapper = styled.div`
text-align: center;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
`;
